module.exports = __webpack_public_path__ + "img/sign-out-icon.7e037e0c.svg";